<template>
    <div>
        <v-card width="200px">
            <v-row cols=12 no-gutters>
                <v-col cols=3 class="mx-1">
                    <h4>Lead</h4>
                </v-col>
                <v-col cols=8 class="mx-1">
                    <!-- <h4>{{ markerData.marker_id }}</h4> -->
                    <h4 @click="$router.open('/pten/onPten/' + markerData.marker_encrid)"><a>{{ markerData.marker_id }}</a></h4>
                </v-col>
            </v-row>
            <v-row cols=12 no-gutters>
                <v-col cols=3 class="mx-1">
                    Agent 
                </v-col>
                <v-col cols=8 class="mx-1">
                    {{ markerData.marker_agent_oms }}
                </v-col>
            </v-row>
            <v-row cols=12 no-gutters>
                <v-col cols=3 class="mx-1">
                    Name 
                </v-col>
                <v-col cols=8 class="mx-1">
                    {{ markerData.marker_name }}
                </v-col>
            </v-row>
            <v-row cols=12 no-gutters>
                <v-col cols=3 class="mx-1">
                    Status 
                </v-col>
                <v-col cols=8 class="mx-1">
                    {{ markerData.marker_status_oms }}
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
    export default {
        props: {
            markerData: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
            }
        },
        methods: { 
        },
    }
</script>

